@layer ui-kit;
@layer ui-kit {
  .pa7z940:is(.pa7z940) {
    height: auto;
  }
  .pa7z945 {
    font-weight: 400;
    font-size: 12px;
    line-height: 1.3;
    letter-spacing: -0.01em;
    margin-top: 4px;
    color: var(--_1qu8za25);
  }
  .pa7z946 {
    font-weight: 400;
    font-size: 14px;
    line-height: 1.3;
    letter-spacing: -0.01em;
    display: flex;
    align-items: center;
    gap: 4px;
  }
}